<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="primary",
    absolute,
    top
  )
  v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
    v-col.py-0.text-right
      v-btn(color="white", @click="save()", :disabled="loading") {{ $t('Common.save') }}

  v-row(v-if="!loading")
    v-col.py-0
      v-card.elevation-24.mb-5
        app-full-entity(:entity="entity", :instance="instance")
          template(v-slot:Brac="props")
            v-form.pa-5
              v-row(justify-end)
                v-col
                  v-text-field(
                    :label="$t('Brac.name')",
                    v-model="instance.name"
                  )
                v-col
                  v-select(
                    :label="$t('Brac.entity')",
                    v-model="instance.entity",
                    :items="$store.state.schema.all",
                    item-text="name",
                    item-value="name",
                    @input="setEntityStore($event)"
)
                v-col
                  v-text-field(
                    :label="$t('Brac.sequence')",
                    v-model="instance.sequence",
                    type="number"
                  )
                v-col.d-flex.align-center.justify-space-around
                  | {{ $t('Brac.executedOn') }}:
                  v-checkbox(
                    :label="$t('Brac.onAdded')",
                    v-model="instance.onAdded"
                  )
                  v-checkbox(
                    :label="$t('Brac.onModified')",
                    v-model="instance.onModified"
                  )
              v-row(justify-end)
                v-col
                  v-btn.primary(fab, x-small, @click="instance = {...instance, fields: [...instance.fields, { name: '', value: '' }]}")
                    v-icon  mdi-plus
              v-row.brac-expression(v-for="(field, i) in instance.fields")

                v-col(cols="5")
                  app-entity-path-selector(
                    :entity="$searchEntity(instance.entity)",
                    :title="field.name",
                    @field="setFieldName(field, $event)", 
                    :clearable="true",
                  )
                v-col(cols="6")
                  g-text-field(
                    :label="$t('Brac.expression')",
                    :value="field.inputValue",
                    @input="setFieldExpression(field, $event)", 
)
                v-col(cols="1").py-0.mb-4.align-self-center
                  g-btn(color="red", outlined, x-small, fab, @click="instance.fields.splice(i, 1)")
                    v-icon  mdi-delete
              .simulation(v-if="instance.entity")
                v-row
                  v-col
                    h2.primaryHover--text Brac {{ $t('Brac.simulation') }}
                v-row
                  v-col
                    app-simple-entity-search(v-model="simulation.instance", :entity="$searchEntity(instance.entity)")
                  v-col.py-0.text-right
                    v-btn(color="white", @click="bracSimulation") {{ $t('Brac.simulation') }}
                v-row
                  v-col(cols="12")
                    h2.primaryHover--text {{ $t('Brac.result') }}
                  v-col(cols="12", v-if="simulation.result.brac")
                    geodis-diff(:oldest="simulation.instance", :newest="simulation.result.instance")
            template(v-for="section in (props.sections || []).filter(x => x.section === entity.name || x.section === entity.tabLabel)")
              app-entity-relation(:path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)")

</template>

<script>
import axios from 'axios'
import GeodisDiff from '@@/components/Diff'
import { removeFirstCriteriaLogicalOperator } from '@@/helpers'

export default {
  components: {
    GeodisDiff
  },
  name: 'brac-add',
  data: () => ({
    simulation: {
      instance: null,
      result: {
        //
      }
    },
    loading: true,
    errors: {},
  }),
  computed: {
    instance: {
      get() {
        return this.$store.state.instance || {}
      },
      set(instance) {
        this.$store.commit('SET_INSTANCE', instance)
      }
    },
    entityName() {
      return 'Brac'
    },
    entity() {
      return this.$searchEntity(this.entityName, 'name')
    },
    uid() {
      return this.$route.params.item
    },
  },
  methods: {
    async bracSimulation() {
      try {
        this.simulation.result = (await axios.post(
          `simulation/bracs/${this.simulation.instance._Entity}/${this.simulation.instance.id}`,
          {
            brac: { ...this.instance, expression: JSON.stringify(this.instance.fields) },
          },
          {
            params: { isSimulation: 'true' }  
          }
        )).data;
      } catch (error) {
        this.errors = error.response.data.errors;
      }
    },
    setFieldName(field, { field: evt, path }) {
      field.name = path;
      field._Entity = evt.extra ? 'ExtraField' : undefined;
      field.extraFieldId = evt.extraFieldId || 0;
      field.extraFieldType = evt.type;
      this.setBracExpression(field)
    },
    setFieldExpression(field, $event) {
      field.inputValue = $event;
      this.setBracExpression(field);
    },
    setBracExpression(field) {
      if (field.inputValue && field.name) {
        var $event = field.inputValue.replace(/Matrix\[(.*?)\]/gm, 'Matrix("$1", @0) ')
        if (field.extraFieldId) {
          field.value = `new(${$event} as EValue, ${field.extraFieldId} as EFieldId, "${field.extraFieldType}" as EType)`
        } else {
          field.value = `new(${$event} as value)`
          //field.value = `new(${$event} as ${field.name})`
        }
      }
      console.log('setBracExpression', this.$cleanString(field))
      return field
    },
    async setEntityStore(rawValue) {
      this.$store.commit('SET_CRITERIA_ENTITY_NAME', this.instance.entity)
    },
    /* TODO: docs */
    async save() {
      // this.loading = true
      try {
        removeFirstCriteriaLogicalOperator(this.instance.criterias);
        this.instance = (await axios.post('entity/graph', { ...this.instance, expression: JSON.stringify(this.instance.fields) })).data
        this.$router.push({
          name: 'entities.index',
          params: { entity: this.entity.name }
        })
      } catch (error) {
        this.errors = error.response.data.errors
      }
      // this.loading = false
    },

    /* TODO: docs */
    async load() {
      if (this.uid) {
        try {
          this.instance.uid = this.uid
          this.instance = {
            ...this.instance, ...(await axios.get(`${this.entity.name}/${this.uid}`, {
              _Entity: this.entity.name,
              uid: this.uid
            })).data
          }
          this.instance.entityState = ENV.ENTITY.STATE.MODIFIED
          var fields = JSON.parse(this.instance.expression) // this.instance.expression.substr(4, this.instance.expression.length -5).split(', ').map(f => ({name: f.split('as ')[1], value: f.split('as ')[0]}))
          this.instance.fields = fields
          this.setEntityStore(this.instance.entity)
        } catch (error) {
          console.error(error)
        }
      } else
        this.$store.commit('SET_INSTANCE', { fields: [] })
      this.loading = false
    }
  },
  created() {
    this.$store.commit('SET_INSTANCE', null)
  },
  async mounted() {
    await this.load()
  }
}
</script>
